import ElementToast from "./ElementToast.svelte";
import { toast } from "@zerodevx/svelte-toast";

type typeValues = "info" | "warning" | "success" | "error";
type selected = {
    bg: string;
    icon: string;
};

function showToast(message: string, type: typeValues = "success"): void {
    let selectedType: selected;

    const toastTypes = {
        info: {
            bg: "#0ea5e9",
            icon: "info",
        },
        warning: {
            bg: "#fbbf24",
            icon: "warning",
        },
        success: {
            bg: "#22c55e",
            icon: "success",
        },
        error: {
            bg: "#e11d48",
            icon: "error",
        },
    };

    // eslint-disable-next-line prefer-const
    selectedType = toastTypes[type];

    toast.pop({ target: "new" });
    toast.push({
        component: {
            src: ElementToast,
            props: {
                message,
                icon: selectedType.icon,
            },
        },
        duration: 3000,
        target: "new",
        theme: {
            "--toastBarHeight": 0,
            "--toastColor": "mintcream",
            "--toastBackground": selectedType.bg,
        },
    });
}

export default showToast;
